import React from 'react';
import styled from 'styled-components';

function ButtonTransparent({className, onClick, children, buttonRef, ariaLabel, name, disabled = false}) {
    return (
        <Button
            name={name ?? ''}
            ref={buttonRef}
            type="button"
            onClick={onClick}
            className={typeof className !== "undefined" ? className : ''}
            aria-label={ariaLabel ?? 'center'}
            disabled={disabled ? 'disabled' : ''}
        >
            {children}
        </Button>
    )
}

export default React.memo(ButtonTransparent);

const Button = styled.button`
  background-color: transparent;
  border-color: transparent;
  padding: 0;
  border: 0;
`;